<template>
  <div id="layout">
    <view-header>
      <h3 class="m-0">Layout (Testing)</h3>
    </view-header>

    <div class="container-fluid p-4">
      <error-renderer/>

      <div class="d-flex">
        <div class="col-6 mr-2 card">
          <div class="card-body">
            <h4>Typography</h4>
            <h1>h1. Heading 1</h1>
            <h2>h2. Heading 2</h2>
            <h3>h3. Heading 3</h3>
            <h4>h4. Heading 4</h4>
            <h5>h5. Heading 5</h5>
            <h6>h6. Heading 6</h6>
            <h4 class="mt-4">Strong (.strong)</h4>
            <h1 class="strong">h1. Heading 1</h1>
            <h2 class="strong">h2. Heading 2</h2>
            <h3 class="strong">h3. Heading 3</h3>
            <h4 class="strong">h4. Heading 4</h4>
            <h5 class="strong">h5. Heading 5</h5>
            <h6 class="strong">h6. Heading 6</h6>
            <h4 class="mt-4">Badges</h4>
            <span class="mr-1 badge badge-primary">Primary</span>
            <span class="mr-1 badge badge-secondary">Secondary</span>
            <span class="mr-1 badge badge-success">Success</span>
            <span class="mr-1 badge badge-danger">Danger</span>
            <span class="mr-1 badge badge-warning">Warning</span>
            <span class="mr-1 badge badge-info">Info</span>
            <span class="mr-1 badge badge-light">Light</span>
            <span class="mr-1 badge badge-dark">Dark</span>
            <h4 class="mt-4">Badges (Light)</h4>
            <span class="mr-1 badge badge-light-primary">Primary</span>
            <span class="mr-1 badge badge-light-secondary">Secondary</span>
            <span class="mr-1 badge badge-light-success">Success</span>
            <span class="mr-1 badge badge-light-danger">Danger</span>
            <span class="mr-1 badge badge-light-warning">Warning</span>
            <span class="mr-1 badge badge-light-dark">Dark</span>
          </div>
        </div>

        <div class="col-6 card">
          <div class="card-body">
            <h4>Text Colors</h4>
            <div class="text-primary">.text-primary</div>
            <div class="text-secondary">.text-secondary</div>
            <div class="text-success">.text-success</div>
            <div class="text-danger">.text-danger</div>
            <div class="text-warning">.text-warning</div>
            <div class="text-info">.text-info</div>
            <div class="text-light bg-dark">.text-light</div>

            <h4 class="mt-4">Font weight</h4>
            <p class="font-weight-lighter">Lighter Text</p>
            <p class="font-weight-light">Light Text</p>
            <p class="font-weight-normal">Normal Text</p>
            <p class="font-weight-bold">Bold Text</p>
            <p class="font-weight-bolder">Bolder Text</p>
            <p class="font-weight-boldest">Boldest Text</p>

            <h4 class="mt-4">Links</h4>
            <div>
              <a href="#">Default link</a>
            </div>

            <h4 class="mt-4">Seperators</h4>
            .separator-dashed
            <div class="separator separator-dashed"></div>
            .separator-solid
            <div class="separator separator-solid">
            </div>

            <h4 class="mt-4">Block-Quote</h4>
            <blockquote class="blockquote">
              <p class="mb-0">Lorem ipsum dolor sit amet. Integer posuere erat a ante.</p>
            </blockquote>
          </div>
        </div>
      </div>

      <div class="d-flex mt-2">
        <div class="col-6 mr-2 card">
          <div class="card-body">
            <h4>Buttons (Default with mr-2)</h4>
            <button type="button" class="mr-2 btn btn-primary">Primary</button>
            <button type="button" class="mr-2 btn btn-secondary">Secondary</button>
            <button type="button" class="mr-2 btn btn-success">Success</button>
            <button type="button" class="mr-2 btn btn-danger">Danger</button>
            <button type="button" class="mr-2 btn btn-warning">Warning</button>
            <button type="button" class="mr-2 btn btn-info">Info</button>
            <button type="button" class="mr-2 btn btn-light">Light</button>
            <button type="button" class="mr-2 btn btn-dark">Dark</button>
            <button type="button" class="mr-2 btn btn-link">Link</button>

            <h4 class="mt-4">Buttons (Outline with mr-2)</h4>
            <button type="button" class="mr-2 btn btn-outline-primary">Primary</button>
            <button type="button" class="mr-2 btn btn-outline-secondary">Secondary</button>
            <button type="button" class="mr-2 btn btn-outline-success">Success</button>
            <button type="button" class="mr-2 btn btn-outline-danger">Danger</button>
            <button type="button" class="mr-2 btn btn-outline-warning">Warning</button>
            <button type="button" class="mr-2 btn btn-outline-info">Info</button>
            <button type="button" class="btn btn-outline-dark">Dark</button>

            <h4 class="mt-4">Buttons (Light with mr-2)</h4>
            <a href="#" class="btn btn-light-success mr-2">Success</a>
            <a href="#" class="btn btn-light-primary mr-2">Primary</a>
            <a href="#" class="btn btn-light-danger mr-2">Danger</a>
            <a href="#" class="btn btn-light-warning mr-2">Warning</a>
            <a href="#" class="btn btn-light-dark">Dark</a>

            <h4 class="mt-4">Buttons (Text Hover with mr-2)</h4>
            <a href="#" class="btn btn-text-success btn-hover-light-success mr-2">Success</a>
            <a href="#" class="btn btn-text-primary btn-hover-light-primary mr-2">Primary</a>
            <a href="#" class="btn btn-text-danger btn-hover-light-danger mr-2">Danger</a>
            <a href="#" class="btn btn-text-warning btn-hover-light-warning mr-2">Warning</a>
            <a href="#" class="btn btn-text-dark btn-hover-light-dark mr-2">Dark</a>

            <h4 class="mt-4">Button Sizes</h4>
            <button type="button" class="mr-2 btn btn-primary btn-sm">Small button</button>
            <button type="button" class="mr-2 btn btn-primary">Default button</button>
            <button type="button" class="btn btn-primary btn-lg">Large button</button>

            <h4 class="mt-4">Block</h4>
            <button type="button" class="btn btn-primary btn-lg btn-block">Block level button
            </button>
            <button type="button" class="btn btn-success btn-lg btn-block">Block level button
            </button>
          </div>
        </div>

        <div class="col-6 card">
          <div class="card-body">
            <h4>Alerts</h4>
            <div class="alert alert-primary" role="alert">
              A simple primary alert
            </div>
            <div class="alert alert-secondary" role="alert">
              A simple secondary alert
            </div>
            <div class="alert alert-success" role="alert">
              A simple success alert
            </div>
            <div class="alert alert-danger" role="alert">
              A simple danger alert
            </div>
            <div class="alert alert-warning" role="alert">
              A simple warning alert
            </div>
            <div class="alert alert-info" role="alert">
              A simple info alert
            </div>
            <div class="alert alert-light" role="alert">
              A simple light alert
            </div>
            <div class="alert alert-dark" role="alert">
              A simple dark alert
            </div>

            <h4 class="mt-4">Alerts Light</h4>
            <div class="alert alert-light-primary" role="alert">
              A simple primary alert
            </div>
            <div class="alert alert-light-success" role="alert">
              A simple success alert
            </div>
            <div class="alert alert-light-danger" role="alert">
              A simple danger alert
            </div>
            <div class="alert alert-light-warning" role="alert">
              A simple warning alert
            </div>
            <div class="alert alert-light-info" role="alert">
              A simple info alert
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex mt-2">
        <div class="col-6 mr-2 card">
          <div class="card-body">
            <h4>Icons</h4>
            <i class="icon icon-spin icon-spinner icon-3x"></i>
            <i class="icon icon-spin icon-circle-o-notch icon-3x"></i>
            <i class="icon icon-pulse icon-spinner icon-3x"></i>
            <i class="icon icon-pulse icon-circle-o-notch icon-3x"></i>
          </div>
        </div>

        <div class="col-6 card">
          <div class="card-body">
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
// Components
import ViewHeader from '../components/General/ViewHeader.vue';
import ErrorRenderer from '../components/Error/ErrorRenderer.vue';

export default {
  name: 'Layout',
  components: {
    ErrorRenderer,
    ViewHeader,
  },
  created() {
  },
  methods: {},
  data() {
    return {};
  },
};
</script>
